<template lang="pug">
  div
    .messenger(v-if="!errorsLogin.length")
      Header(@requestChatsNextPage="getRecentChatsNextPage(0, $event);")
      .messenger_wrap(v-if="!recentChats.length && !requestingRecentChats")
        .messenger_zero
          p(v-html="$t('hints.zeroState', { url: refLink })")
      .messenger_wrap(v-else)
        .messenger_contacts(:class="{ 'hidden_mobile': groupCreate || activeChat || ticketCreate }")
          //- .contacts_search(:class="{ 'disabled': groupCreate || ticketCreate }")
            //- input.contacts_search__item(
            //- type="text",
            //- placeholder="Search")
            //- v-icon.search_icon(size="24") mdi-magnify
          //- .contacts_actions(:class="{ 'disabled': groupCreate || ticketCreate }")
          //-   v-menu.contacts_menu(nudge-bottom="40", nudge-left="20")
          //-     template(v-slot:activator="{ on }")
          //-       .action(v-on="on")
          //-         SvgMsgCreate
          //-         span {{ $t('actions.create') }}
          //-     .link_tooltip
          //-       .link_tooltip__item(@click="newGroup")
          //-         SvgMsgGroup
          //-         span {{ $t('actions.newGroup') }}
          //-       .link_tooltip__item(@click="newTicket")
          //-         SvgMsgAsk
          //-         span {{ $t('actions.askSupport') }}
          .contacts_wrap(ref="contactList")
            ChatList(
              :data="recentChats",
              :creatingGroup="groupCreate",
              @cancelGroupCreation="groupCreate = false",
              :disabled="groupCreate || ticketCreate")
            intersect(v-if="recentChatsMeta && recentChatsMeta.next_page", @enter="onIntersectEnter")
              #next_page_recent
            //- ContactList(
            //-   :title="$t('common.contacts')",
            //-   :data="contacts",
            //-   type="contact",
            //-   :disabled="groupCreate || ticketCreate")
        .messenger_chat(:class="{ 'hidden_mobile': !groupCreate && !activeChat && !ticketCreate }")
          .messenger_chat__empty(v-if="!activeChat && !groupCreate") {{ $t('hints.selectChatToStartMessaging') }}
          .messenger_chat__wrap(v-if="activeChat && !groupCreate")
            ChatHeader(
              :chat="activeChat",
              :ticketCreate="ticketCreate",
              @clickLeaveChat="leaveChat",
              @clickJoinChat="joinChat",
              @clickBack="handleClickBack")
            .chat_services(v-if="servicesSection")
              MessagesServicesItem(
                v-for="item in services",
                :key="item.id",
                :services="item")
            .chat_content(ref="chatContent", infinite-wrapper, @scroll="handleContentScroll")
              Preloader(v-if="loading")
              .next_page_wrap(v-else-if="activeChatMetaTo && activeChatMetaTo.next_page")
                intersect(:root="$refs.chatContent", @enter="onIntersectEnter")
                  #next_page_messages
              .chat_content_block(
                v-if="activeChatMessages",
                v-for="(value, key) in activeChatMessages")
                .chat_date(:class="{ loading }") {{ getMessagesDate(key) }}
                ChatMessageItem(
                  v-for="(item, index) in value",
                  :root="$refs.chatContent",
                  :key="'msg_' + index",
                  :chatTypeId="activeChat.type_id",
                  :loading="loading",
                  :message="item",
                  :unreadNumber="activeChatUnreadNumber",
                  @messageFullyInsected="readMessage")
              .chat_zero_message(v-else) {{ $t('common.noMessagesInChat') }}
              .scroll_bottom_btn(v-if="scrollBottomBtnVisible && !loading", @click="scrollChatToBottom")
                span
                  SvgArrowThin
                  .unread_count(v-if="activeChatUnreadNumber") {{ activeChatUnreadNumber }}
              #prev_page_wrap.prev_page_wrap
                intersect(v-if="activeChatMetaFrom && activeChatMetaFrom.next_page", @enter="onIntersectEnter")
                  #prev_page_messages
              .chat_content_errors(v-if="messageSentErrors && messageSentErrors.length")
                .msg_error(v-for="(message, index) in messageSentErrors", :key="'msg_err_' + index") {{ message }}
              intersect(:root="$refs.chatContent", @enter="onIntersectEnter", @leave="onIntersectLeave")
                #chat_bottom
            .chat_input(v-if="chatInputVisible")
              //- label.input_btn.input_attach
              //-   input(type="file")
              //-   SvgMsgAttach
              v-textarea(
                v-model="newMessage",
                auto-grow,
                solo,
                hide-details,
                :rows="1",
                :placeholder="$t('actions.write') + '...'",
                @keydown="onNewMessageKeyDown")
              .input_btn.input_send(@click="sendMessage")
                SvgMsgSend(:class="{ disabled: !newMessage.trim().length || sendingMsg }")
          CreateGroup(v-if="groupCreate", @clickCreate="createGroupChat", @cancelGroupCreation="groupCreate = false")
    v-snackbar.inform(
      v-if="commonErrors.length",
      v-model="snackbar",
      top,
      multi-line,
      color="error",
      :timeout="60*60*1000")
      div(v-for="e in commonErrors") {{ e.message }}
      v-btn(v-if="commonErrors.some(e => e.message && e.message.includes('email'))", text, @click="goToVerification") {{ $t('actions.verify') }}
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import Header from '@/components/TheHeader';
import ChatList from '@/components/ChatList';
import ContactList from '@/components/ContactList';
import ChatHeader from '@/components/ChatHeader';
import ChatMessageItem from '@/components/ChatMessageItem';
import CreateGroup from '@/components/CreateGroup';
import MessagesServicesItem from '@/components/MessagesServicesItem';
import ModerationMenu from '@/components/ModerationMenu';
import Intersect from '@/components/Intersect';
import Preloader from '@/components/Preloader';

import SvgMsgSend from '@/components/svg/SvgMsgSend';
import SvgArrowThin from '@/components/svg/SvgArrowThin';// import SvgMsgAsk from '@/components/svg/SvgMsgAsk';
// import SvgMsgCreate from '@/components/svg/SvgMsgCreate';
// import SvgMsgGroup from '@/components/svg/SvgMsgGroup';
// import SvgMsgAttach from '@/components/svg/SvgMsgAttach';

import socket from '@/socket';
import {
  UPDATE_RECENT_CHATS,
  SET_ACTIVE_CHAT_MESSAGES,
  SET_ACTIVE_CHAT,
  SET_ACTIVE_CHAT_ID,
  UPDATE_ACTIVE_CHAT_MESSAGES,
  LEAVE_CHAT,
  JOIN_CHAT,
  SET_RECENT_CHATS,
  SET_REQUESTING_MESSAGES_CHAT_ID,
  ADD_ACTIVE_CHAT_NEW_MESSAGE,
  UPDATE_LAST_MESSAGE,
  RESET_RECENT_CHATS,
  SLICE_ACTIVE_CHAT_MESSAGES,
  MARK_ACTIVE_CHAT_AS_READ
} from '@/store/modules/chats/types';
import { SET_MESSAGE_SENT_ERRORS, SET_GROUP_CHAT_CREATION_ERRORS } from '@/store/modules/user/types';
import { UPDATE_ACTIVITY_STATUS } from '@/store/modules/users/types';
import { cutStringInChunks, processErrors } from '@/utils';
import CONSTANTS from '@/constants';

export default {
  components: {
    Header,
    ChatList,
    ContactList,
    ChatHeader,
    ChatMessageItem,
    CreateGroup,
    MessagesServicesItem,
    ModerationMenu,
    Intersect,
    Preloader,
    SvgMsgSend,
    SvgArrowThin
    // SvgMsgCreate,
    // SvgMsgAsk,
    // SvgMsgGroup,
    // SvgMsgAttach
  },
  data() {
    return {
      snackbar: true,
      loading: false,
      requestingRecentChats: false,
      sendingMsg: false,
      newMessage: '',
      scrollOptions: {
        easing: 'easeOutCubic',
        duration: 900,
        offset: 30
      },
      chatBottomVisible: false,
      scrollBottomBtnVisible: false,
      maxMessageLength: CONSTANTS.maxMessageLength,
      messagesPerPage: CONSTANTS.messagesPageSize,
      chatTypes: CONSTANTS.chatTypes,
      messageTypes: CONSTANTS.messageTypes,
      groupView: false,
      groupCreate: false,
      servicesSection: false,
      ticketCreate: false,
      items: [
        'Programming',
        'Design',
        'Vue',
        'Vuetify'
      ],
      firstPagePartial: {}
    };
  },
  computed: {
    ...mapGetters('chats', {
      activeChatMessages: 'getActiveChatMessagesByDates',
      getMessageById: 'getMessageById',
      messagesToRequestParam: 'getMessagesToRequestParam',
      messagesFromRequestParam: 'getMessagesFromRequestParam'
    }),
    ...mapState('user', [
      'avatar_url',
      'contacts',
      'messageSentErrors',
      'loggedIn',
      'errorsLogin',
      'errorsCommon'
    ]),
    ...mapState('chats', [
      'activeChatId',
      'activeChat',
      'requestingMessagesChatId',
      'recentChats',
      'recentChatsMeta',
      'activeChatMetaFrom',
      'activeChatMetaTo',
      'activeChatFirstUnread',
      'reconnectionAttempts'
    ]),
    commonErrors() {
      return this.errorsLogin.concat(this.errorsCommon);
    },
    unreadMessagesScrollOffset() {
      const messages = this.$store.state.chats.activeChatMessages;

      if (!messages || !messages.length) return 0;
      return this.activeChat.unread > 1 ? -Math.trunc(window.innerHeight / 2 - 160) : this.scrollOptions.offset;
    },
    authUserId() {
      return this.$store.state.user.id;
    },
    chatInputVisible() {
      if (this.activeChat.left_at) return false;

      if (this.activeChat.type_id === this.chatTypes.channel && (!this.activeChat.last_message || this.authUserId !== this.activeChat.last_message.user_id)) {
        return false;
      }

      return true;
    },
    activeChatUnreadNumber() {
      const count = this.$store.state.chats.unreadMessagesCount[this.activeChat.id] || 0;

      if (count === 1000) return '1K';

      if (count > 1000) {
        const str = count.toString();

        return `${str.charAt(0)}K+`;
      }

      return count;
    },
    refLink() {
      return `${process.env.VUE_APP_KICKREF}/referral-program`;
    }
  },
  watch: {
    reconnectionAttempts(newVal, oldVal) {
      if (newVal > 0) return;

      if (this.requestingMessagesChatId && this.recentChats.find(i => i.id === this.requestingMessagesChatId)) {
        this.getMessagesFirstPage(this.recentChats.find(i => i.id === this.requestingMessagesChatId));
      }

      this.sendingMsg = false;

      if (oldVal < 4 && this.newMessage) {
        this.sendMessage();
      }
    },
    activeChatFirstUnread(val) {
      if (val) {
        this.$refs.chatContent.scrollTop = 0;
        setTimeout(this.goToUnreadSeparator, 0);
        // this.$nextTick(() => this.goToUnreadSeparator());
      }
    },
    groupCreate(val) {
      if (val) {
        setTimeout(() => {
          this.$vuetify.goTo('#newGroupChat', { ...this.scrollOptions, container: this.$refs.contactList });
        }, 0);
      }
    },
    activeChat: {
      handler(chat, prevChat) {
        if (chat && prevChat && chat.id === prevChat.id) return;

        if (chat && chat.id && this.requestingMessagesChatId !== chat.id) {
          this.getMessagesFirstPage(chat);
        }

        if (!chat) {
          this.$store.commit(`chats/${SET_ACTIVE_CHAT_MESSAGES}`, { messages: null, users: {}, meta: null });
        }

        this.$store.commit(`user/${SET_MESSAGE_SENT_ERRORS}`, null);
      },
      deep: true
    },
    recentChats: {
      handler(newVal, oldVal) {
        if (!oldVal.length && newVal.length && this.activeChatId) {
          const chat = newVal.find(i => i.id === this.activeChatId);

          if (chat) {
            this.$store.commit(`chats/${SET_ACTIVE_CHAT}`, chat);
          }

          this.$store.commit(`chats/${SET_ACTIVE_CHAT_ID}`, null);
        }
      },
      deep: true
    },
    recentChatsMeta: {
      handler(val) {
        return val;
      },
      deep: true
    },
    activeChatMetaFrom: {
      handler(val) {
        return val;
      },
      deep: true
    },
    activeChatMetaTo: {
      handler(val) {
        return val;
      },
      deep: true
    }
  },
  methods: {
    goToUnreadSeparator() {
      console.log('!!!!!GO TO ', document.querySelector('#unread_sep').getBoundingClientRect(), this.unreadMessagesScrollOffset);

      if (document.querySelector('#unread_sep')) {
        document.querySelector('#unread_sep').scrollIntoView();
        // this.$vuetify.goTo('#unread_sep', {
        //   ...this.scrollOptions,
        //   // offset: this.unreadMessagesScrollOffset,
        //   container: this.$refs.chatContent
        // });

        this.loading = false;
      }
    },
    handleResponse(response, callbackFn, request = {}) {
      if (!response.errors) {
        callbackFn(response);
        return;
      }

      if (response.errors.length && response.errors.some(err => err.message.toLowerCase().includes('unauthorized'))) {
        const cb = () => {
          socket.signin(() => socket.emit(request.type, request.payload, res => callbackFn(res)));
        };

        socket.refreshSession(cb);
      }
    },
    setActiveChatMessages(requestedType, data) {
      if (data.users && Object.keys(data.users).length) {
        Object.values(data.users).forEach(user => {
          this.$store.commit(`users/${UPDATE_ACTIVITY_STATUS}`, { user_id: user.id, active_at: user.active_at });
        });
      }

      if (requestedType === 'unread') {
        if (this.activeChat.last_read_id) {
          this.firstPagePartial.unread = data;
        } else {
          this.$store.commit(`chats/${SET_ACTIVE_CHAT_MESSAGES}`, data);
          this.$store.commit(`chats/${SET_REQUESTING_MESSAGES_CHAT_ID}`, null);
          this.loading = false;

          return;
        }
      }

      if (requestedType === 'read') {
        this.firstPagePartial.read = data;
      }

      if (this.firstPagePartial.read && this.firstPagePartial.unread) {
        const messages = [];

        if (this.firstPagePartial.unread.messages) {
          messages.push(...this.firstPagePartial.unread.messages);
        }

        if (this.firstPagePartial.read.messages) {
          messages.push(...this.firstPagePartial.read.messages);
        }

        messages.sort((a, b) => b.id - a.id);

        const users = { ...this.firstPagePartial.unread.users, ...this.firstPagePartial.read.users };
        const mergedData = {
          messages,
          users,
          meta: {
            to: {
              next_page: this.firstPagePartial.read.meta.next_page,
              to: this.firstPagePartial.read.meta.to,
              per_page: this.firstPagePartial.read.meta.per_page
            }
          }
        };

        if (this.firstPagePartial.unread.meta.next_page) {
          mergedData.meta.from = {
            per_page: this.firstPagePartial.unread.meta.per_page,
            next_page: this.firstPagePartial.unread.meta.next_page,
            from: this.firstPagePartial.unread.meta.from
          };
        }

        this.$store.commit(`chats/${SET_ACTIVE_CHAT_MESSAGES}`, mergedData);
        this.$store.commit(`chats/${SET_REQUESTING_MESSAGES_CHAT_ID}`, null);

        if (!messages.length) {
          this.loading = false;
          return;
        }

        if (messages.every(i => i.is_read)) {
          setTimeout(() => {
            const height = this.$refs.chatContent.scrollHeight;
            this.$refs.chatContent.scrollTop = height;
            this.loading = false;
          }, 0);
        }
      }
    },
    updateActiveChatMessages(savedScrollHeight, direction, data) {
      this.$store.commit(`chats/${UPDATE_ACTIVE_CHAT_MESSAGES}`, { ...data, direction });
      this.$store.commit(`chats/${SET_REQUESTING_MESSAGES_CHAT_ID}`, null);

      this.$nextTick(() => {
        const diff = this.getExceedMessagesNumber();

        if (direction === 'next') {
          this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollTop + this.$refs.chatContent.scrollHeight - savedScrollHeight;
        }

        if (diff > 0) {
          this.$store.commit(`chats/${SLICE_ACTIVE_CHAT_MESSAGES}`, { diff, direction });

          if (direction === 'prev') {
            const heightDiff = savedScrollHeight - this.$refs.chatContent.scrollHeight;

            if (heightDiff < 0) {
              this.$refs.chatContent.scrollTop -= Math.abs(heightDiff);
            }
          }
        }

        this.$refs.chatContent.style['overflow-y'] = 'auto';
      });
    },
    onIntersectEnter(entry) {
      switch (entry.target.id) {
        case 'next_page_recent':
          if (this.recentChatsMeta && this.recentChatsMeta.next_page) {
            this.getRecentChatsNextPage(this.recentChatsMeta.from);
          }
          break;
        case 'next_page_messages':
          if (this.activeChatMetaTo && this.activeChatMetaTo.next_page) this.getMessagesNextPage();
          break;
        case 'prev_page_messages':
          if (this.activeChatMetaFrom && this.activeChatMetaFrom.next_page) this.getMessagesPrevPage();
          break;
        case 'chat_bottom':
          this.chatBottomVisible = true;
          break;
        default: break;
      }
    },
    onIntersectLeave(entry) {
      if (!entry.isIntersecting && entry.target.id === 'chat_bottom') {
        this.chatBottomVisible = false;
      }
    },
    getRecentChatsNextPage(from = 0, chatType = 0) {
      if (this.requestingRecentChats) return;

      this.requestingRecentChats = true;

      const request = {
        type: 'recent-chats',
        payload: {
          from,
          per_page: this.recentChatsMeta.per_page
        }
      };

      if (chatType) {
        request.payload.chat_type_id = chatType;
      }

      const cb = response => {
        const privateChats = response.chats.filter(chat => !!chat.contact);

        if (privateChats.length) {
          privateChats.forEach(chat => {
            this.$store.commit(`users/${UPDATE_ACTIVITY_STATUS}`, { user_id: chat.contact.id, active_at: chat.contact.active_at });
          });
        }

        this.$store.commit(`chats/${SET_RECENT_CHATS}`, response);
        this.requestingRecentChats = false;
      };

      const responseCb = response => this.handleResponse(response, cb);

      socket.emit(request.type, request.payload, responseCb);
    },
    getMessagesFirstPage(chat) {
      if (!chat.last_read_id) {
        this.requestOneFirstPage(chat);
      } else {
        this.requestTwoFirstPages(chat);
      }
    },
    requestOneFirstPage(chat) {
      const request = {
        type: 'chat-messages',
        payload: {
          chat_id: chat.id,
          meta: { per_page: this.messagesPerPage }
        }
      };
      const responseCb = response => this.handleResponse(response, this.setActiveChatMessages.bind(null, 'unread'), request);

      this.$store.commit(`chats/${SET_REQUESTING_MESSAGES_CHAT_ID}`, chat.id);
      socket.emit(request.type, request.payload, responseCb);
    },
    requestTwoFirstPages(chat) {
      const requestUnread = {
        type: 'chat-messages',
        payload: {
          chat_id: chat.id,
          meta: { from: chat.last_read_id, per_page: Math.trunc(this.messagesPerPage / 2) }
        }
      };

      const requestRead = {
        type: 'chat-messages',
        payload: {
          chat_id: chat.id,
          meta: { to: chat.last_read_id, per_page: Math.trunc(this.messagesPerPage / 2) }
        }
      };

      const responseUnreadCb = response => this.handleResponse(response, this.setActiveChatMessages.bind(null, 'unread'), requestUnread);
      const responseReadCb = response => this.handleResponse(response, this.setActiveChatMessages.bind(null, 'read'), requestRead);

      this.$store.commit(`chats/${SET_REQUESTING_MESSAGES_CHAT_ID}`, chat.id);

      socket.emit(requestUnread.type, requestUnread.payload, responseUnreadCb);
      socket.emit(requestRead.type, requestRead.payload, responseReadCb);
    },
    getMessagesNextPage() {
      if (this.requestingMessagesChatId === this.activeChat.id) return;

      this.$store.commit(`chats/${SET_REQUESTING_MESSAGES_CHAT_ID}`, this.activeChat.id);

      const request = {
        type: 'chat-messages',
        payload: {
          chat_id: this.activeChat.id,
          meta: {
            to: this.messagesToRequestParam,
            per_page: this.activeChatMetaTo.per_page
          }
        }
      };

      const savedScrollHeight = this.$refs.chatContent.scrollHeight;
      const responseCb = response => this.handleResponse(response, this.updateActiveChatMessages.bind(null, savedScrollHeight, 'next'), request);

      socket.emit(request.type, request.payload, responseCb);
      this.$refs.chatContent.style['overflow-y'] = 'hidden';
    },
    getMessagesPrevPage() {
      if (this.requestingMessagesChatId === this.activeChat.id) return;

      this.$store.commit(`chats/${SET_REQUESTING_MESSAGES_CHAT_ID}`, this.activeChat.id);

      const request = {
        type: 'chat-messages',
        payload: {
          chat_id: this.activeChat.id,
          meta: {
            from: this.messagesFromRequestParam + 1,
            per_page: this.activeChatMetaFrom.per_page || this.messagesPerPage
          }
        }
      };

      const savedScrollHeight = this.$refs.chatContent.scrollHeight;
      const responseCb = response => this.handleResponse(response, this.updateActiveChatMessages.bind(null, savedScrollHeight, 'prev'), request);

      socket.emit(request.type, request.payload, responseCb);
      this.$refs.chatContent.style['overflow-y'] = 'hidden';
    },
    readMessage(messageId) {
      const message = this.getMessageById(messageId);

      if (message && !message.is_read) {
        socket.emit('read-message', { message_id: messageId });
      }
    },
    getMessagesDate(date) {
      if (new Date().toISOString().slice(0, 10) === date) {
        return 'Today';
      }

      return this.$options.filters.messageDate(date, this.$i18n.locale);
    },
    onNewMessageKeyDown(event) {
      if (event.keyCode !== 13) return;

      if (!event.shiftKey && !event.ctrlKey) {
        event.preventDefault();
        this.sendMessage();
      }

      if (event.ctrlKey) this.newMessage += '\n';
    },
    sendMessage() {
      if (!this.newMessage || !this.newMessage.trim().length || this.sendingMsg) return;

      this.sendingMsg = true;
      this.newMessage = this.newMessage.replace(/^\n+|\n+$/g, '');

      if (this.newMessage.length <= 2048) {
        this.sendSingleMessage(this.newMessage, this.activeChat.id);
      } else {
        const chunks = cutStringInChunks(this.newMessage, this.maxMessageLength);

        chunks.forEach(message => {
          this.sendSingleMessage(message, this.activeChat.id);
        });
      }
    },
    sendSingleMessage(message, chatId) {
      const request = {
        type: 'message',
        payload: { chat_id: chatId, message }
      };
      const responseCb = response => this.handleResponse(response, this.handleMessageError, request);

      socket.emit(request.type, request.payload, responseCb);
    },
    scrollChatToBottom() {
      if (this.activeChatUnreadNumber) {
        this.$store.commit(`chats/${MARK_ACTIVE_CHAT_AS_READ}`);
        socket.emit('read-messages-all', { chat_id: this.activeChat.id });
      }

      if (document.querySelector('#chat_bottom')) {
        this.$vuetify.goTo('#chat_bottom', { ...this.scrollOptions, container: this.$refs.chatContent });
      }
    },
    leaveChat(chatId) {
      const request = {
        type: 'leave-chat',
        payload: { chat_id: chatId }
      };

      const responseCb = response => this.handleResponse(response, this.$store.commit.bind(null, `chats/${LEAVE_CHAT}`), request);

      socket.emit(request.type, request.payload, responseCb);
    },
    joinChat(chatId) {
      const request = {
        type: 'join-chat',
        payload: { chat_id: chatId }
      };

      const cb = response => {
        this.$store.commit(`chats/${JOIN_CHAT}`, response);
        this.getMessagesFirstPage(response);
      };

      const responseCb = response => this.handleResponse(response, cb, request);

      socket.emit(request.type, request.payload, responseCb);
    },
    createGroupChat(payload) {
      const request = {
        type: 'create-group-chat',
        payload
      };

      const responseCb = response => this.handleResponse(response, this.onChatCreated, request);

      socket.emit(request.type, request.payload, responseCb);
    },
    handleClickBack() {
      this.groupCreate = false;
      this.ticketCreate = false;
      this.$store.commit(`chats/${SET_ACTIVE_CHAT}`, null);
    },
    handleNewMessage(message) {
      const chatIndex = this.recentChats.findIndex(item => item.id === message.chat_id);

      if (chatIndex !== -1 && this.activeChat && this.activeChat.id === message.chat_id) {
        this.$store.commit(`chats/${ADD_ACTIVE_CHAT_NEW_MESSAGE}`, message);
      }

      if (message.message_type_id === this.messageTypes.user) {
        if (chatIndex === -1) {
          this.$store.commit(`chats/${RESET_RECENT_CHATS}`);
          this.getRecentChatsNextPage(0);
        } else {
          this.$store.commit(`chats/${UPDATE_LAST_MESSAGE}`, { message, chatIndex });
        }
      }

      if (!this.activeChat) return;

      if (message.user_id && message.user_id === this.authUserId) {
        this.newMessage = '';
        this.sendingMsg = false;
        this.$store.commit(`user/${SET_MESSAGE_SENT_ERRORS}`, null);
      }

      if ((message.user_id && message.user_id === this.authUserId) || this.chatBottomVisible) {
        this.scrollChatToBottom();
      }
    },
    handleMessageError(data) {
      if (data.errors && data.errors.length) {
        this.$store.commit(`user/${SET_MESSAGE_SENT_ERRORS}`, processErrors(data.errors));
        this.scrollChatToBottom();
        this.sendingMsg = false;
      }
    },
    onChatCreated(data) {
      if (data.errors) {
        this.$store.commit(`user/${SET_GROUP_CHAT_CREATION_ERRORS}`, processErrors(data.errors));
      } else {
        this.$store.commit(`chats/${UPDATE_RECENT_CHATS}`, data);
        this.groupCreate = false;
        this.$store.commit(`user/${SET_GROUP_CHAT_CREATION_ERRORS}`, null);
      }
    },
    handleMessengerReconnect() {
      const cb = () => {
        if (this.activeChat && this.requestingMessagesChatId !== this.activeChat.id) {
          this.getMessagesFirstPage(this.activeChat);
        }

        this.$store.commit(`chats/${RESET_RECENT_CHATS}`);

        this.getRecentChatsNextPage(0);
      };

      socket.signin(cb);
    },
    handleContentScroll(ev) {
      if (ev.target.scrollHeight - ev.target.scrollTop > 1000) {
        this.scrollBottomBtnVisible = true;
      } else {
        this.scrollBottomBtnVisible = false;
      }
    },
    goToVerification() {
      this.snackbar = false;
      window.location.href = process.env.VUE_APP_SETTINGS;
    },
    getExceedMessagesNumber() {
      if ((this.$store.state.chats.activeChatMessages.length) <= CONSTANTS.activeChatMaxLimit) return 0;

      return this.$store.state.chats.activeChatMessages.length - CONSTANTS.activeChatMaxLimit;
    },
    servicesActive() { this.servicesSection = true; },
    allActive() { this.servicesSection = false; },
    newGroup() { this.groupCreate = true; },
    newTicket() { this.ticketCreate = true; }
  },
  mounted() {
    if (this.activeChatId && this.recentChats.length) {
      const chat = this.recentChats.find(i => i.id === this.activeChatId);
      if (chat) {
        this.$store.commit(`chats/${SET_ACTIVE_CHAT}`, chat);
      }

      this.$store.commit(`chats/${SET_ACTIVE_CHAT_ID}`, null);
    }

    if (this.activeChat && this.requestingMessagesChatId !== this.activeChat.id) {
      this.getMessagesFirstPage(this.activeChat);
    }

    this.$eventHub.$on('newMessage', this.handleNewMessage);
    this.$eventHub.$on('chatClicked', () => { this.loading = true; });
    this.$eventHub.$on('socketConnected', this.handleMessengerReconnect);

    this.$eventHub.$on('chatJoined', chat => {
      this.$store.commit(`chats/${UPDATE_RECENT_CHATS}`, chat);
      this.$store.commit(`chats/${SET_ACTIVE_CHAT}`, chat);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off('newMessage');
    this.$eventHub.$off('chatClicked');
    this.$eventHub.$off('socketConnected');
    this.$eventHub.$off('chatJoined');
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .messenger {
    max-height: 100vh;
    overflow: hidden;

    &__close {
      width: 24px;
      min-width: 24px;
      height: 24px;
      outline: none;
      transform: rotate(45deg);
      margin: auto 0 auto auto;
      opacity: 0.54;
      fill: $grey-text;

      @media screen and (max-width: 1024px) {
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }

    &_wrap {
      display: flex;
      width: 100%;
      max-width: 1120px;
      padding: 40px 20px 0;
      margin: auto;
      height: calc(100vh - 80px);

      @media screen and (max-width: 1024px) {
        max-width: 100%;
        padding: 20px 20px 0;
        height: calc(100vh - 130px);
      }

      @media screen and (max-width: 500px) {
        padding-top: 0;
        padding-left: 10px;
        padding-right: 10px;

        .chat_content { margin-bottom: 30px; }

        ::v-deep .contact_item:last-child {
          border-bottom: 0 !important;
        }
      }
    }

    &_zero {
      padding: 0 20px;
      line-height: 24px;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      color: $light-theme-text;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      max-width: 600px;
      margin: 0 auto;
    }

    &_contacts {
      max-width: 404px;
      width: 100%;
      box-sizing: border-box;
      max-height: 100%;
      position: relative;

      @media screen and (max-width: 1024px) {
        max-width: 100%;
      }

      .contacts {
        &_wrap {
          padding-right: 44px;
          overflow: auto;
          height: 100%;
          max-height: calc(100% - 30px);
          position: relative;

          @media screen and (max-width: 1024px) { padding-right: 0; }
        }

        &_search {
          display: flex;
          max-width: 322px;
          margin: 10px auto 20px;
          position: relative;
          box-sizing: content-box;
          padding-right: 41px;

          @media screen and (max-width: 1024px) {
            padding-right: 0;
            max-width: 100%;
          }

          .search_icon {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            height: 24px;
            display: block;
            left: 105px;
            transition: all .3s;

            @media screen and (max-width: 1024px) { left: 20px; }
          }

          &__item {
            background: $light-theme-line;
            width: 100%;
            text-align: left;
            line-height: normal;
            font-size: 16px;
            font-weight: 600;
            padding: 14px 20px 12px;
            border-radius: 25px;
            outline: none;
            transition: all .3s;

            &::placeholder {
              transition: all .3s;
              text-align: center;

              @media screen and (max-width: 1024px) {
                text-align: left;
                padding-left: 30px;
              }
            }

            &:focus {
              ~ .search_icon {
                opacity: 0;
                transition: all .3s;
              }

              &::placeholder {
                opacity: 0;
                transition: all .3s;
              }
            }
          }
        }

        &_group {
          padding: 12px 0 6px;
          background: $light-theme-line;
          width: 100%;
          position: relative;
          margin-bottom: 47px;

          &::after {
            content: '';
            top: 0;
            position: absolute;
            height: 100%;
            background: $light-theme-line;
            width: 100vw;
            left: -100vw;
          }

          @media screen and (max-width: 1024px) {
            &::before {
              content: '';
              top: 0;
              position: absolute;
              height: 100%;
              background: $light-theme-line;
              width: 100vw;
              right: -100vw;
            }

            .group_wrap { margin: auto; }
          }

          .group {
            &_logotype {
              background-size: cover;
              width: 18px;
              min-width: 18px;
              height: 18px;
              margin-right: 6px;
              border-radius: 50%;
            }

            &_title {
              font-size: 16px;
              text-align: center;
              font-weight: bold;
            }

            &_wrap {
              display: flex;
              justify-content: center;
              max-width: 360px;

              @media screen and (max-width: 1024px) { max-width: 100%; }
            }
          }
        }

        &_head {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          padding: 0 21px 0 23px;
          position: sticky;
          top: -1px;
          background: $white;
          z-index: 3;

          @media screen and (max-width: 1024px) {
            padding-right: 10px;
            padding-left: 10px;
          }

          &::after {
            content: '';
            background: linear-gradient(180deg, $white 0%, $avatar-gradient-to 100%);
            height: 30px;
            width: 100%;
            position: absolute;
            bottom: -29px;
            left: 0;
          }
        }

        &_title {
          line-height: normal;
          font-size: 16px;
          font-weight: 600;
          color: $grey-text;
        }

        &_list {
          margin-bottom: 21px;

          &:last-child { margin-bottom: 0; }
        }

        &_actions {
          padding-right: 64px;
          display: flex;
          justify-content: flex-end;
          z-index: 2;
          position: relative;
          margin-bottom: 10px;

          @media screen and (max-width: 1024px) { padding-right: 20px; }
        }
      }

      &.group {
        .contacts_actions {
          justify-content: space-between;
          margin-bottom: 28px;
        }

        .contacts_wrap {
          max-height: calc(100% - 150px);
          padding-bottom: 71px;
        }

        .v-menu { position: initial; }
      }

      #next_page_recent {
        height: 10px;
        visibility: hidden;
      }
    }

    &_chat {
      width: 100%;
      position: relative;
      // padding-left: 52px;

      &::before {
        content: '';
        position: absolute;
        left: -1px;
        top: 0;
        background: $light-theme-line;
        width: 2px;
        height: 100%;
        max-height: calc(100% - 20px);
      }

      &__wrap {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      &__empty {
        line-height: 24px;
        font-size: 14px;
        text-align: center;
        font-weight: 500;
        color: $light-theme-text;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }

      .chat {
        &_zero_message { margin: auto; }

        &_services { z-index: 2; }

        &_content {
          overflow-y: auto;
          overflow-x: hidden;
          height: 100%;
          padding-top: 50px;
          position: relative;

          .scroll_bottom_btn {
            position: sticky;
            bottom: 0;
            width: 80px;
            height: 80px;
            margin-left: calc(100% - 60px);

            span {
              display: block;
              width: 60px;
              height: 60px;
              background: $sub-black;
              border-radius: 50%;
              cursor: pointer;
              box-shadow: 0px 10px 15px $black-1;
              position: relative;

              svg {
                fill: $white !important;
                transform: rotate(-90deg);
                width: 35px;
                margin-top: 14px;
              }

              .unread_count {
                position: absolute;
                top: 0;
                right: 0;
                line-height: normal;
                font-size: 10px;
                font-variant-numeric: tabular-nums;
                text-align: center;
                color: $white;
                background: $error-color;
                font-weight: 600;
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
              }
            }
          }

          .next_page_wrap {
            position: absolute;
            top: 25%;
            width: 100%;
            height: 10px;
            visibility: hidden;
          }

          .prev_page_wrap { position: relative; }

          &_block {
            display: flex;
            flex-direction: column;
            align-items: baseline;
          }

          #chat_bottom,
          #next_page_messages,
          #prev_page_messages {
            height: 10px;
            visibility: hidden;
          }

          #prev_page_messages {
            position: absolute;
            width: 100%;
            left: 0;
            top: -150px;
          }

          .msg_error {
            font-size: 12px;
            color: $error-color;
          }
        }

        &_date {
          line-height: normal;
          font-size: 12px;
          text-align: center;
          color: $light-theme-text;
          font-weight: 600;
          margin-bottom: 16px;
          align-self: center;
          opacity: 1;
          transition: opacity .3s $easing;

          &.loading { opacity: 0; }
        }

        &_input {
          position: sticky;
          bottom: 0;
          background: $white;
          width: 100%;
          display: flex;

          ::v-deep .v-input {
            width: 100%;
            border-radius: 25px;
            padding: 15px 16px 13px;
            font-weight: 500;
            font-size: 16px;
            line-height: 25px;
            outline: none;

            &__control {
              background: $light-theme-line !important;
              box-shadow: none !important;
            }

            &.v-input--is-focused .v-input__slot { border-color: transparent !important; }

            &__slot {
              box-shadow: none !important;
              background: none !important;
              border: 1px solid transparent !important;
            }

            textarea {
              max-height: 30vh;
              overflow-y: auto;
              -ms-overflow-style: none;

              &::-webkit-scrollbar { display: none; }
            }
          }

          .input {
            &_btn {
              display: flex;
              align-items: center;
              cursor: pointer;

              input[type='file'] { display: none; }
            }

            &_send svg {
              padding: 2px;

              &.disabled {
                fill: $light-theme-text;
                cursor: default;
              }
            }
          }

          svg {
            width: 24px;
            height: 24px;
            fill: $blue;
          }
        }
      }

      @media screen and (max-width: 1024px) {
        z-index: 12;
        background: $white;
        padding-left: 0;

        &::before { display: none; }
      }
    }

    .preloader {
      position: absolute;
      left: calc(50% - 90px);
      top: calc(50% - 30px);
    }
  }

  // Transition animation
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s $easing;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .link_tooltip {
    background: $white;
    position: relative;

    &::before {
      content: '';
      width: 30px;
      height: 30px;
      background: $white;
      border-radius: 6px;
      position: absolute;
      top: -30px;
      transform: rotate(45deg);
      right: 90px;

      @media screen and (max-width: 690px) { right: 20px; }
    }

    &__item {
      color: $blue;
      display: flex;
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 10px;
      cursor: pointer;

      &:last-child { margin-bottom: 0; }

      svg {
        fill: $blue;
        width: 16px;
        height: 16px;
        margin-right: 13px;
        margin-top: 3px;
      }
    }
  }

  .action {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    color: $blue;
    font-weight: 600;
    font-size: 16px;

    svg {
      width: 20px;
      height: 20px;
      fill: $blue;
      margin-right: 9px;
    }
  }

  .v-menu {
    z-index: 2;

    &__content {
      border-radius: 15px;
      background: $white;
      padding: 20px 20px 15px;
      overflow: visible;
      contain: none;
      width: 100%;
      max-width: 197px;
      box-shadow: 0 0 6px $light-theme-05, 0 -10px 70px $light-theme-08;

      @media screen and (max-width: 690px) { max-width: 200px; }
    }

    &__activator--active span { color: $orange-3; }
  }

  @media screen and (max-width: 1024px) {
    .hidden_mobile { display: none; }
  }

  .disabled {
    pointer-events: none;
    opacity: .3;
  }
</style>
